import {DataServiceBase} from "../DataServiceBase";

export class DependentsService extends DataServiceBase{
    constructor() {
        super('/Profile/GetDependents');
    }
}